exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n  margin-right: 10px; }\n\n.PhoneButtonSection__button___nYH1H {\n  margin-top: 20px;\n  text-decoration: underline;\n  text-align: center;\n  font-weight: 300;\n  font-size: 15px;\n  color: #000000; }\n  .PhoneButtonSection__button___nYH1H:focus {\n    outline: none; }\n  .PhoneButtonSection__button___nYH1H:hover {\n    color: #f94144; }\n\n.PhoneButtonSection__externalLink___3ky3j {\n  margin-top: 12px;\n  margin-bottom: 15px;\n  background-color: transparent;\n  height: 50px;\n  width: 100%;\n  font-weight: 700;\n  line-height: 23px;\n  font-size: 15px;\n  color: #000000;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #f94144; }\n", ""]);

// exports
exports.locals = {
	"button": "PhoneButtonSection__button___nYH1H",
	"externalLink": "PhoneButtonSection__externalLink___3ky3j"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/ContactSection/PhoneButtonSection/PhoneButtonSection.scss
// module id = 4497
// module chunks = 6